<script setup>
import { ref } from 'vue'

const getImageSrc= (image)=>{
  return (new URL(`../../assets/images/main_page/${image}`, import.meta.url)).href
}
const comments = ref([
  {
    role:'مادر دانش آموز',
    avatar:'Mother.png',
    text:' پسرم سال گذشته با اساتید کلاسینو کلاس داشتند که فوق العاده پیشرفت داشته و کاملا با پایه اش قوی شده شکر خدا<br> برای سال آینده باز هم ثبت نامش میکنم واقعا اساتید مهربان و کاربلدی هستند تشکر ویژه دارم از همشون'
  },
  {
    role:'دانش آموز',
    avatar:'Girl.png',
    text:'امروز اولین جلسه ام را در سایتتون داشتم. خیلی خوب بود. هم اساتید عالی بودند و هم کلاس خیلی راحت باز می شد. 👏👏👏'
  },
  {
    role:'مادر دانش آموز',
    avatar:'Mother.png',
    text:'من از خود استاد تشکر کردم ولی دوست دارم همه اولیا ها بدونن که کلاسینو چه اساتیدی داره دخترم ریاضی رو از هیچ به 17 رسوند نمیدونید چقدرررر خوشحالم '
  },
  {
    role:'دانش آموز',
    avatar:'Boy.png',
    text:' ریاضیییییییی واقعا عااالی بود اولین نفر دادم برگمو 🤸 <br> اینقدر خوشحالم ک دارم پرواز میکنم 😂😂'
  },
  {
    role:'مادر دانش آموز',
    avatar:'Mother.png',
    text:'دل تو دلم نیست تابستان بیاد ومن کلاس‌های پایه هشتم رو ثبت نام کنم دوست دارم وقتی دختر به مرحله کنکور رسید رتبه خوبی بیاره و شما اعلام کنید 6سال با کلاسینو و رتبه برتر🤩🤩'
  },
  {
    role:' دانش آموز',
    avatar:'Mother.png',
    text:'سلام به اساتید محترم کلاسینو و از استاد های مهربون خیلی تشکر میکنم که برامون اینقدر تلاش میکنن واقعا برامون مدرسه دوم درست کردن من خودم یکی از دانش آموزای نهمی کلاسینو هستم من امروز کارنامه مو گرفتم خیلی خوشحالم درسته نفر سومم ولی یکی از دانش آموزان ممتاز مدرسه شدم و همشو مدیون شما و استاد های مهربون هستم 🌹🌹🌹🌹'
  },
  {
    role:' دانش آموز',
    avatar:'Girl.png',
    text:'سلااااام روزتون بخیر خسته نباشید 💜   یه خبر خیلییییی خووب… <br>امروز یه طرح نوی مدرسمون بود که هر کسی داوطلب بشه و سه تا درس رو به عنوان معلم بشه و کنفرانس بده. من درس های ریاضی، عربی و شیمی رو انتخاب کردم. خیلییی استرس داشتم که بد توضیح بدم ولی وقتی خواستم شروع کنم سعی کردم دقیقا حرف های استاد رو بگم… بچه ها همشون میگفتن خیلی خوب فهمیدن استادهامم خیلی راضی بودن ازم خیلی اعتماد به نفس گرفتم 😌'
  }
])
</script>

<template>
  <v-row>
    <v-col cols="12">
      <v-carousel
        :height="$vuetify.display.xlAndUp? '380': '420'"
        :show-arrows="$vuetify.display.lgAndUp"
        hide-delimiters
        class="">
        <template v-slot:prev="{ props }">
          <i class="icon-angle-right slider-prev" @click="props.onClick"></i>
        </template>
        <template v-slot:next="{ props }">
          <i class="icon-angle-left slider-next" @click="props.onClick"></i>
        </template>
        <v-carousel-item v-for="(comment, index) in comments" :key="index">
          <div class="d-flex align-items-center h-100">
            <v-card
              min-height="280px"
              :width="$vuetify.display.mdAndDown?'95%': '90%'"
              variant="flat"
              style="background: #FAFAFA;"
              class="rounded-lg mx-auto position-relative d-flex justify-content-center flex-column overflow-visible py-4 px-3" :class="[$vuetify.display.mdAndDown?'flex-column justify-content-center pa-4':'']">
              <v-list-item >
                <template v-slot:prepend>
                  <v-img
                    :src="getImageSrc(comment.avatar)"
                    :width="$vuetify.display.mdAndDown ? 72 : 72"
                    class="mx-3"
                  />
                </template>
                <v-list-item-title class="student__name text-wrap font-weight-bold">
                  {{comment.role}}
                </v-list-item-title>
                <template v-slot:append>
                  <v-img :src="getImageSrc('qoute.svg')"  class="comment__qoute__img"/>
                </template>
              </v-list-item>
              <div class="d-flex mx-auto my-3 student__comment" style="" v-html="comment.text">
              </div>
            </v-card>
          </div>
        </v-carousel-item>
      </v-carousel>
    </v-col>
  </v-row>
</template>

<style scoped lang="scss">
.comment__qoute__img{
  width: 102px;
  transform: rotate(180deg);
}
.student__name{
  font-size: 1.3rem;
  @include media-breakpoint-down(md){
    font-size: 1.1rem;

  }
}
.student__comment{
  width: 95%;
  line-height: 32px;
  @include media-breakpoint-down(md){
    font-size: 12px;
  }
}
</style>
